import type { ConsoleRole } from '@plato/shared';

export interface McpServerRow {
  readonly name: string;
  readonly title: string | null;
  readonly url: string;
  readonly enabled: boolean;
  readonly credential: 'session_token' | 'oauth_refresh' | 'user_sign_in' | 'user_api_key';
}

export interface NewMcpServer {
  readonly name: string;
  readonly title: string;
  readonly url: string;
  readonly connectWith: 'sign_in' | 'api_key';
  readonly clientId?: string;
  readonly clientSecret?: string;
}

export function isConnectedByEachUser(server: McpServerRow): boolean {
  return server.credential === 'user_sign_in' || server.credential === 'user_api_key';
}

export interface ToolRow {
  readonly source: string;
  readonly kind: 'mcp';
  readonly sourceEnabled: boolean;
  readonly name: string;
  readonly title: string | null;
  readonly sourceDescription: string | null;
  readonly description: string | null;
  readonly descriptionReplaced: boolean;
  readonly enabled: boolean;
  readonly lastSeenAt: string | null;
}

export interface ToolChange {
  readonly enabled?: boolean;
  readonly description?: string | null;
}

export interface IntegrationSetup {
  readonly apiOrigin: string;
  readonly embedOrigin: string;
  readonly publishableKey: string | null;
  readonly allowedOrigins: readonly string[];
  readonly mcpServers: readonly McpServerRow[];
}

export interface ApiKeyRow {
  readonly id: string;
  readonly kind: 'secret' | 'publishable';
  readonly mode: 'test' | 'live';
  readonly createdAt: string;
  readonly revokedAt: string | null;
  readonly publishableKey: string | null;
}

export interface CreatedKey {
  readonly keyId: string;
  readonly value: string;
}

export interface MemberRow {
  readonly id: string;
  readonly name: string;
  readonly email: string | null;
  readonly role: ConsoleRole;
  readonly joinedAt: string;
}

export interface InviteRow {
  readonly id: string;
  readonly email: string;
  readonly role: ConsoleRole;
  readonly expiresAt: string;
}

export interface TeamView {
  readonly members: readonly MemberRow[];
  readonly invites: readonly InviteRow[];
}

export interface CreatedInvite {
  readonly inviteId: string;
  readonly link: string;
}

export interface AuditEventRow {
  readonly id: string;
  readonly at: string;
  readonly actor: string;
  readonly event: string;
  readonly details: Readonly<Record<string, unknown>>;
}
